import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoModule,
  TranslocoService,
} from '@ngneat/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

const SUPPORTED_LANGS = ['en', 'ar', 'ru'] as const;

function normalizeLanguage(rawLang: string | null): string | null {
  if (!rawLang) {
    return null;
  }

  const normalizedLang = rawLang.toLowerCase().replace('_', '-').split('-')[0];
  return SUPPORTED_LANGS.includes(normalizedLang as (typeof SUPPORTED_LANGS)[number])
    ? normalizedLang
    : null;
}

function getInitialLanguage(): string {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const queryLanguage = normalizeLanguage(
    new URLSearchParams(window.location.search).get('kc_locale'),
  );
  if (queryLanguage) {
    window.localStorage.setItem('lang', queryLanguage);
    return queryLanguage;
  }

  return normalizeLanguage(window.localStorage.getItem('lang')) || 'en';
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      // Provide the default Transloco configuration
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [
          {
            id: 'en',
            label: 'English',
          },
          {
            id: 'ar',
            label: 'Arabic',
          },
          {
            id: 'ru',
            label: 'Russian',
          },
        ],
        defaultLang: getInitialLanguage(),
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      }),
    },
    {
      // Provide the default Transloco loader
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader,
    },
    {
      // Preload the default language before the app starts to prevent empty/jumping content
      provide: APP_INITIALIZER,
      deps: [TranslocoService],
      useFactory:
        (translocoService: TranslocoService): any =>
        (): Promise<Translation> => {
          const defaultLang = translocoService.getDefaultLang();
          translocoService.setActiveLang(defaultLang);
          return translocoService.load(defaultLang).toPromise();
        },
      multi: true,
    },
  ],
})
export class TranslocoCoreModule {}
